import useSWR from 'swr';
import { backendClient } from '@/lib/api-client';

export type DeadlineTagCategory = 'litigation' | 'key_dates';

export interface DeadlineTagVocabularyItem {
  label: string;
  color: string;
  /** Which exclusive family the tag belongs to (used to group the tag filter). */
  category: DeadlineTagCategory;
}

interface TagVocabularyResponse {
  tags: DeadlineTagVocabularyItem[];
}

/** The controlled deadline-tag vocabulary (label + palette colour) for a matter.
 *  Static server-side, so it is cached aggressively and not revalidated on focus. */
export function useTagVocabulary(matterGuid: string | undefined) {
  const { data, error, isLoading } = useSWR<DeadlineTagVocabularyItem[]>(
    matterGuid ? `/deadlines/${matterGuid}/tag-vocabulary` : null,
    async (url: string) => {
      const response = await backendClient.get<TagVocabularyResponse>(url);
      return response.data.tags ?? [];
    },
    { revalidateOnFocus: false, dedupingInterval: 3_600_000 },
  );

  return { vocabulary: data ?? [], isLoading, isError: Boolean(error) };
}
